import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import { 
    IsXsDownScreen
} from '../../../business-components/Service/GlobalService'

import {
    GridContainer,
    GridItem1,
    GridItem2,
    GridItem2xs1,
    GridItem3,
    GridItem3xs6,
    GridItem4,
    GridItem4xs6,
    GridItem6,
    GridItem6xs10,
    GridItem8xs12,
    GridItem9xs10,
    GridItem10,
    GridItem12,
    GridItem3xs12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDividerElementos,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    TextFieldNumberSelectDestaque,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    dadosCompletosConjuge,
} from '../cliente-form/ClienteService'

import {
    possuiFilhao,
} from '../cadastro-form/CadastroServiceFamiliares'

import {
    TipoReceitaMensal,
    IconButtonClearEntradaDadosReceitaMensal,
    ValorBruto,
    Valor,
    TipoPeriodicidadeRecebto,
    ValorInssPensaoInvalidez,
    ValorInssPensaoMorte,
    ValorInssPensaoAposentadoria,
    AlterarValorInssPensaoMorteAposentadoria,
    HelpInssInvalidezMorteAposentadoria,
    PeriodoReceitaMensal,
    AlterarTipoCalculoAcumulado,
    MesAnoInicial,
    MesAnoFinal,
    ReceitaMensalAteAposentadoria,
    NaoConsiderarGarantiaMorteCliente,
    NaoConsiderarGarantiaMorteConjuge,
    NaoConsiderarGarantiaInvalidezCliente,
    NaoConsiderarGarantiaInvalidezConjuge,
    HelpNaoConsiderarGarantiaMorteInvalidez,
    TemSeguroVidaEmGrupo,
    TipoMultiploSalarioSeguroVidaEmGrupo,
    ValorCSSeguroVidaEmGrupoMorte,
    ValorCSSeguroVidaEmGrupoMorteAcidental,
    ValorCSSeguroVidaEmGrupoInvalidezPorAcidente,
    ValorCSSeguroVidaEmGrupoInvalidezFuncionalPorDoenca,
    ValorCSSeguroVidaEmGrupoDoencasGraves,
    ValorCSSeguroVidaEmGrupoFuneral,
    ExtensivelClienteConjuge,
    PercExtensivelClienteConjuge,
    ExtensivelFilhao,
    PercExtensivelFilhao,
    Seguradora,
    SeguradoraOutras,
    DescricaoOutras,
    HelpDescricaoOutras,
    Observacao,
} from './GarantiasCompReceitaMensal'



const GarantiasFormReceitaMensalItem = ({ values, handleChange, setFieldValue, arrayHelpers, tipoReceitaMensalSelecionada,
    tipoMultiploSalarioSeguroVidaEmGrupoSelecionado, item, ind, simplificado }) => {

    const isXsDownScreen = IsXsDownScreen()

    return (
 
        <CardGridEntradaDados>
            <CardGridDivHeaderEntradaDados>
                <GridContainer>
                    <GridItem9xs10>
                        <TipoReceitaMensal
                            TextFieldNumberSelectTipoReceitaMensal={
                                TextFieldNumberSelectDestaque
                            }
                            values={values}
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                        />
                    </GridItem9xs10>
                    <GridItem2xs1/>
                    <GridItem1>
                        <IconButtonClearEntradaDadosReceitaMensal
                            values={values}
                            setFieldValue={setFieldValue}
                            item={item}
                            ind={ind}
                            arrayHelpers={arrayHelpers}
                            simplificado={simplificado}
                        />
                    </GridItem1>
                </GridContainer>
            </CardGridDivHeaderEntradaDados>

            <CardGridDivBodyEntradaDados
                style={{
                    display: 
                        item.tipoReceitaMensal
                            ? "block"
                            : "none"
                }} 
            >
                <GridContainer>
                    {tipoReceitaMensalSelecionada.informaValorBruto === "S" && (
                        <GridItem4xs6>
                            <ValorBruto
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                            />
                        </GridItem4xs6>
                    )}
                    <GridItem4xs6>
                        <Valor
                            values={values}
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                            //tipoReceitaMensalSelecionada={tipoReceitaMensalSelecionada}
                        />
                    </GridItem4xs6>
                    <GridItem4xs6>
                        <TipoPeriodicidadeRecebto
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                        />
                    </GridItem4xs6>
                </GridContainer>
                
                <GridContainer>
                    <GridItem10>
                        <DescricaoOutras
                            item={item}
                            ind={ind}
                            handleChange={handleChange} 
                        />
                    </GridItem10>
                    <GridItem2>
                        <HelpDescricaoOutras/>
                    </GridItem2>
                </GridContainer>

                {(
                    tipoReceitaMensalSelecionada.informaInssPensao === "I" ||
                    tipoReceitaMensalSelecionada.informaInssPensao === "P"
                ) && (
                    <>
                        <GridContainer>
                            <GridItem4xs6>
                                <ValorInssPensaoInvalidez
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                    tipoReceitaMensalSelecionada={tipoReceitaMensalSelecionada}
                                    simplificado={false}
                                />
                            </GridItem4xs6>
                            <GridItem4xs6>
                                <ValorInssPensaoMorte
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                    tipoReceitaMensalSelecionada={tipoReceitaMensalSelecionada}
                                />
                            </GridItem4xs6>
                            <GridItem4xs6>
                                <ValorInssPensaoAposentadoria
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                    tipoReceitaMensalSelecionada={tipoReceitaMensalSelecionada}
                                />
                            </GridItem4xs6>
                        </GridContainer>
                    </>
                )}

                {(
                    tipoReceitaMensalSelecionada.informaInssPensao === "I" ||
                    tipoReceitaMensalSelecionada.informaInssPensao === "P"
                ) && (
                    <GridContainer>
                        {!isXsDownScreen && (
                            <GridItem4 />
                        )}

                        <GridItem6xs10>
                            <AlterarValorInssPensaoMorteAposentadoria
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                                tipoReceitaMensalSelecionada={tipoReceitaMensalSelecionada}
                            />
                        </GridItem6xs10>

                        <GridItem1>
                            <HelpInssInvalidezMorteAposentadoria/>
                        </GridItem1>
                    </GridContainer>
                )}

                <GridContainer>
                    {!item.alterarTipoCalculoAcumulado && (
                        <GridItem8xs12
                            className={'mt-3 ' + (isXsDownScreen ? 'mb-2' : 'mb-4')}
                        >
                            <PeriodoReceitaMensal
                                tipoReceitaMensalSelecionada={tipoReceitaMensalSelecionada}
                            />
                        </GridItem8xs12>
                    )}
                    
                    {tipoReceitaMensalSelecionada.permiteAlterarTipoCalculoAcumulado === 'S' &&
                    item.tipoPeriodicidadeRecebto !== HARDCODE.idTipoPeriodicidadeUnica && (
                        <GridItem3xs12>
                            <AlterarTipoCalculoAcumulado
                                values={values}
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                                tipoReceitaMensalSelecionada={tipoReceitaMensalSelecionada}
                            />
                        </GridItem3xs12>
                    )}

                    {item.alterarTipoCalculoAcumulado && (
                        <>
                            {!isXsDownScreen && (
                                <GridItem1 />
                            )}
                            <GridItem3xs6>
                                <MesAnoInicial
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem3xs6>
                            <GridItem3xs6>
                                {!item.receitaMensalAteAposentadoria &&
                                item.tipoPeriodicidadeRecebto !== HARDCODE.idTipoPeriodicidadeUnica && (
                                    <MesAnoFinal
                                        item={item}
                                        ind={ind}
                                        handleChange={handleChange}
                                    />
                                )}
                            </GridItem3xs6>

                            {item.tipoPeriodicidadeRecebto !== HARDCODE.idTipoPeriodicidadeUnica && (
                                <GridItem12>
                                    <ReceitaMensalAteAposentadoria
                                        item={item}
                                        ind={ind}
                                        handleChange={handleChange}
                                    />
                                </GridItem12>
                            )}
                        </>
                    )}
                </GridContainer>

                {(item.familiar === HARDCODE.idFamiliarCliente ||
                item.familiar === HARDCODE.idFamiliarConjuge ||
                item.familiar === HARDCODE.idFamiliarCasal) && (
                    <>
                        <CardGridDividerElementos/>
                        
                        <GridContainer>
                            <GridItem10>
                                <NaoConsiderarGarantiaMorteCliente
                                    values={values}
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem10>

                            {dadosCompletosConjuge(values, true) && (
                                <GridItem10>
                                    <NaoConsiderarGarantiaMorteConjuge
                                        values={values}
                                        item={item}
                                        ind={ind}
                                        handleChange={handleChange}
                                    />
                                </GridItem10>
                            )}

                            <GridItem10>
                                <NaoConsiderarGarantiaInvalidezCliente
                                    values={values}
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem10>

                            {dadosCompletosConjuge(values, true) && (
                                <GridItem10>
                                    <NaoConsiderarGarantiaInvalidezConjuge
                                        values={values}
                                        item={item}
                                        ind={ind}
                                        handleChange={handleChange}
                                    />
                                </GridItem10>
                            )}

                            <GridItem1>
                                <HelpNaoConsiderarGarantiaMorteInvalidez/>
                            </GridItem1>
                        </GridContainer>
                    </>
                )}

                {tipoReceitaMensalSelecionada.informaSeguroVidaEmGrupo === "S" && (
                    <>
                        <CardGridDividerElementos/>

                        <GridContainer>
                            <GridItem6>
                                <TemSeguroVidaEmGrupo
                                    values={values}
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem6>
                        </GridContainer>
                    </>
                )}

                {item.temSeguroVidaEmGrupo  && item.valorBruto && (
                    <GridContainer>
                        <GridItem6>
                            <TipoMultiploSalarioSeguroVidaEmGrupo
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                            />
                        </GridItem6>
                        {item.tipoMultiploSalarioSeguroVidaEmGrupo && (
                            <GridItem6>
                                <ValorCSSeguroVidaEmGrupoMorte
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                    tipoMultiploSalarioSeguroVidaEmGrupoSelecionado={
                                        tipoMultiploSalarioSeguroVidaEmGrupoSelecionado
                                    }
                                />
                            </GridItem6>
                        )}
                    </GridContainer>
                )}

                {item.tipoMultiploSalarioSeguroVidaEmGrupo && item.valorBruto && (
                    <>
                        <GridContainer>
                            <GridItem6>
                                <ValorCSSeguroVidaEmGrupoMorteAcidental
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                    tipoMultiploSalarioSeguroVidaEmGrupoSelecionado={
                                        tipoMultiploSalarioSeguroVidaEmGrupoSelecionado
                                    }
                                />
                            </GridItem6>
                            <GridItem6>
                                <ValorCSSeguroVidaEmGrupoInvalidezPorAcidente
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                    tipoMultiploSalarioSeguroVidaEmGrupoSelecionado={
                                        tipoMultiploSalarioSeguroVidaEmGrupoSelecionado
                                    }
                                />
                            </GridItem6>
                        </GridContainer>

                        <GridContainer>
                            <GridItem6>
                                <ValorCSSeguroVidaEmGrupoInvalidezFuncionalPorDoenca
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                    tipoMultiploSalarioSeguroVidaEmGrupoSelecionado={
                                        tipoMultiploSalarioSeguroVidaEmGrupoSelecionado
                                    }
                                />
                            </GridItem6>
                            <GridItem6>
                                <ValorCSSeguroVidaEmGrupoDoencasGraves
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem6>
                        </GridContainer>
                        
                        <GridContainer>
                            <GridItem6>
                                <ValorCSSeguroVidaEmGrupoFuneral
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem6>
                        </GridContainer>
                    </>
                )}

                {item.tipoMultiploSalarioSeguroVidaEmGrupo &&
                item.valorBruto &&
                dadosCompletosConjuge(values, true) &&
                (
                    item.familiar === HARDCODE.idFamiliarCliente ||
                    item.familiar === HARDCODE.idFamiliarConjuge
                ) && (
                    <GridContainer>
                        <GridItem6>
                            <ExtensivelClienteConjuge
                                values={values}
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                            />
                        </GridItem6>
                        {item.extensivelClienteConjuge && (
                            <GridItem4>
                                <PercExtensivelClienteConjuge
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4>
                        )}
                    </GridContainer>
                )}

                {item.tipoMultiploSalarioSeguroVidaEmGrupo &&
                item.valorBruto &&
                possuiFilhao(values) &&
                (
                    item.familiar === HARDCODE.idFamiliarCliente ||
                    item.familiar === HARDCODE.idFamiliarConjuge
                ) && (
                    <GridContainer>
                        <GridItem6>
                            <ExtensivelFilhao
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                            />
                        </GridItem6>
                        {item.extensivelFilhao && (
                            <GridItem3>
                                <PercExtensivelFilhao
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem3>
                        )}
                    </GridContainer>
                )}

                {item.tipoMultiploSalarioSeguroVidaEmGrupo && item.valorBruto && (
                    <GridContainer>
                        <GridItem6>
                            <Seguradora
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                            />
                        </GridItem6>
                        {item.seguradora === HARDCODE.idSeguradoraOutras && (
                            <GridItem6>
                                <SeguradoraOutras
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem6>
                        )}
                    </GridContainer>
                )}

                <CardGridDividerElementos/>
                
                <GridContainer>
                    <GridItem12>
                        <Observacao
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                        />
                    </GridItem12>
                </GridContainer>
            </CardGridDivBodyEntradaDados>
        </CardGridEntradaDados>
    )
}

export default GarantiasFormReceitaMensalItem